import app from "@/main";
import {DosyaBorclu} from "../../../uyap/DosyaBorclu";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {UyapHacizEvrakTuru} from "../../../enum/uyap/evrak/UyapHacizEvrakTuru";
import TakipDosya from "../../../uyap/classes/TakipDosya";
import {ITarafBilgisiDetayliTarafRollu} from "../../../uyap/GetDosyaTarafListesiWithTarafRol";

/** Bu metinlerde tüm dosya hazırlığı iptal edilir; diğer talep/borçlu sorgulanmaz. */
export const UYAP_HACIZ_HAZIRLA_FATAL_SKIP_MESSAGES: readonly string[] = [
    "Borçlu hakkındaki icra takibi kesinleştirilmediği için sorgulama yapamazsınız. ",
    "Bu işlemi bu dosya için gerçekleştiremezsiniz. Dosyada ALACAKLI vekili değilsiniz. ",
];

const UYAP_ESZAMANLI_SORGU_ERROR_CODE = "PRTL_GNL_10001-61";

/** Kurum (tüzel kişi) borçlunun maaşı olmadığı için maaş haczi talebi gönderilemiyor. */
export const KURUM_MAAS_HACZI_MESAJI = "Kurum borçlular için maaş haczi talebi gönderilemez.";

function uyapThrownMessage(e: unknown): string {
    if (e != null && typeof e === "object") {
        const o = e as { message?: string; error?: string };
        if (typeof o.message === "string" && o.message.length > 0) return o.message;
        if (typeof o.error === "string") return o.error;
    }
    if (e instanceof Error) return e.message;
    return String(e);
}

function uyapThrownErrorCode(e: unknown): string | undefined {
    if (e != null && typeof e === "object") {
        const c = (e as { errorCode?: string }).errorCode;
        if (typeof c === "string" && c.length > 0) return c;
    }
    return undefined;
}

export function isUyapHacizHazirlaFatalSkipMessage(message: string | undefined): boolean {
    if (!message) return false;
    return UYAP_HACIZ_HAZIRLA_FATAL_SKIP_MESSAGES.includes(message);
}

export class TopluHacizHazirlaTaskCevap {
    dosya: TakipDosya;
    borclular: DosyaBorclu[] = [];
    params: IHacizParams;
    // 89-1/2/3 için dosyanın 3. şahıs (taraf) listesi önden çekilir (badge sayısı + çoklu form için)
    ucuncuSahisList: ITarafBilgisiDetayliTarafRollu[] = [];

    constructor(dosya: TakipDosya, params: IHacizParams) {
        this.dosya = dosya;
        this.params = params;
    }
}

export class TopluTalepGonderTaskCevap {
    dosya: TakipDosya;
    borclu: DosyaBorclu;
    params: IHacizParams;

    constructor(dosya: TakipDosya, params: IHacizParams, borclu: DosyaBorclu) {
        this.dosya = dosya;
        this.params = params;
        this.borclu = borclu;
    }
}

interface IHacizParams {
    hacizParams: any[],
    tebligatParams: any[],
    digerTalepParams: any[],
}

export class TopluHacizHazirlaTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        try {
            let dosya = await app.$uyap.DosyaBul().run(task);
            let response: TopluHacizHazirlaTaskCevap = new TopluHacizHazirlaTaskCevap(dosya, task.data);
            await dosya.borclularQuery();
            let hacizParams = task.data.hacizParams;
            const ucretliSorguyaDevamEt = !!task.data.ucretliSorguyaDevamEt;
            if (Object.keys(hacizParams).length > 0) {
                for (const borclu of dosya.borclular) {
                    console.log("BORCLU ", borclu);
                    for (const param of hacizParams) {
                        try {
                            if (param.talepKodu == UyapHacizEvrakTuru.egm) {
                                await borclu.queryEgm(dosya.dosyaId, ucretliSorguyaDevamEt);
                                await borclu.queryEgmMahrumiyet(dosya.dosyaId);
                            }
                            if (param.talepKodu == UyapHacizEvrakTuru.takbis) {
                                console.log("TAKBİS SORGULANIYOR", task);
                                await borclu.queryBorcluTakbis(dosya.dosyaId, ucretliSorguyaDevamEt);
                                //await borclu.queryTasinmazHisse(dosya.dosyaId);
                                //await borclu.queryTasinmazTakyidat(dosya.dosyaId);
                            }
                            if (param.talepKodu == UyapHacizEvrakTuru.banka_haczi)
                                await borclu.queryBorcluBankaBilgileri(dosya.dosyaId, ucretliSorguyaDevamEt);
                            if (param.talepKodu == UyapHacizEvrakTuru.posta_ceki_haciz)
                                await borclu.queryBorcluPostaCeki(dosya.dosyaId, ucretliSorguyaDevamEt);
                            // Kurum borçlunun maaşı olmadığı için maaş haczi talebi oluşmuyor; SGK
                            // sorguları da boşuna kota/bakiye harcamasın diye kurumda hiç yapılmıyor.
                            if (param.talepKodu == UyapHacizEvrakTuru.maas_haczi && borclu.isKurum()) {
                                borclu.sgkhaciz.message = KURUM_MAAS_HACZI_MESAJI;
                                continue;
                            }
                            if (param.talepKodu == UyapHacizEvrakTuru.maas_haczi) {
                                await borclu.queryBorcluSsk(dosya.dosyaId);
                                await borclu.queryBorcluSgkBagkur(dosya.dosyaId);
                                await borclu.queryBorcluSgkKamu(dosya.dosyaId);
                                await borclu.queryBorcluEmekliSsk(dosya.dosyaId);
                                await borclu.queryBorcluEmekliBagkur(dosya.dosyaId);
                                await borclu.queryBorcluEmekliKamu(dosya.dosyaId);
                                await borclu.queryBorcluSgkIsyeri(dosya.dosyaId);
                                await borclu.queryBorcluSgkHaciz(dosya.dosyaId, ucretliSorguyaDevamEt);
                            }
                            // sgk_mossip_haczi
                            if (param.talepKodu == UyapHacizEvrakTuru.sgk_mossip_haczi) {
                                await borclu.queryBorcluSgkMossip(dosya.dosyaId);
                            }
                            if (param.talepKodu == UyapHacizEvrakTuru.alacakli_oldugu_dosya)
                                await borclu.queryBorcluIcraDosyaKaydi(dosya.dosyaId, ucretliSorguyaDevamEt);
                        } catch (e) {
                            const err: unknown = e;
                            console.error("HATA: ", err);
                            const msg = uyapThrownMessage(err);
                            if (isUyapHacizHazirlaFatalSkipMessage(msg)) {
                                throw new Error(msg);
                            }
                            if (uyapThrownErrorCode(err) === UYAP_ESZAMANLI_SORGU_ERROR_CODE) {
                                throw err;
                            }
                            console.log("HATA (sorgu atlanıyor, devam)");
                        }
                    }
                }
                // 89-1/2/3 talebi varsa dosyanın 3. şahıs (taraf) listesini önden çek
                const ihbarnameTalepVar = hacizParams.some((p: any) =>
                    p.talepKodu == UyapHacizEvrakTuru.ihbarname89_1 ||
                    p.talepKodu == UyapHacizEvrakTuru.ihbarname89_2 ||
                    p.talepKodu == UyapHacizEvrakTuru.ihbarname89_3
                );
                if (ihbarnameTalepVar) {
                    try {
                        response.ucuncuSahisList = await app.$uyap.GetDosyaTarafListesiWithTarafRol().run({
                            dosyaId: dosya.dosyaId,
                            islemTuru: 26
                        });
                    } catch (e) {
                        const err: unknown = e;
                        const msg = uyapThrownMessage(err);
                        if (isUyapHacizHazirlaFatalSkipMessage(msg)) {
                            throw new Error(msg);
                        }
                        if (uyapThrownErrorCode(err) === UYAP_ESZAMANLI_SORGU_ERROR_CODE) {
                            throw err;
                        }
                        console.log("3. şahıs listesi alınamadı (atlanıyor, devam)", err);
                    }
                }
            }
            response.params = task.data;
            response.borclular = dosya.borclular;
            response.dosya = dosya;
            task.response = response;
            return task;
        } catch (e) {
            console.log('TopluHacizHazirlaTaskHandler Error', e);
            throw e;
        }
    }
}